import { Const } from '@app/shared/util/constants';
import { Component, OnInit, HostListener } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'iw-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {

  constructor() {}

  ngOnInit() { }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: Event) {
    if (document.getElementById('body-task')) {
      if (document.getElementById('headerFlowStatic')) {
        document.getElementById('headerFlowStatic').classList.add('d-none');
      }
      if ($event.srcElement['scrollTop'] > document.getElementById('body-task').offsetTop) {
        if (document.getElementById('header-task-static')) {
          document.querySelector('#header-task-static').classList.remove('d-none');
        }
      } else {
        if (document.getElementById('header-task-static')) {
          document.querySelector('#header-task-static').classList.add('d-none');
        }
      }
    } else if (document.getElementById('headerFlow')) {
      if ($event.srcElement['scrollTop'] > document.getElementById('headerFlow').offsetTop) {
        if (document.getElementById('headerFlowStatic')) {
          // document.querySelector('#headerFlowStatic').classList.add('container-static');
          document.querySelector('#headerFlowStatic').classList.remove('d-none');
        }
      } else {
        if (document.getElementById('headerFlowStatic')) {
          // document.querySelector('#headerFlowStatic').classList.remove('container-static');
          document.querySelector('#headerFlowStatic').classList.add('d-none');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/shell/shell.component.ts